module.exports = __webpack_public_path__ + "img/pre_rotate.d1e43dfa.png";